import React from 'react';

import { postWebUiApi } from '../../api';
import { WebUiAlert } from '../../components/alert';
import WebUiPageWrapper from '../../components/page-wrapper';

type Counter = {
  interface: number;
  ifInOctets?: number;
  ifInUcastPkts?: number;
  ifInNUcastPkts?: number;
  ifInDiscards?: number;
  ifInErrors?: number;
  ifOutOctets?: number;
  ifOutUcastPkts?: number;
  ifOutNUcastPkts?: number;
  ifOutDiscards?: number;
  ifOutErrors?: number;
};

const f = (n?: number) => (typeof n === 'number' ? n.toLocaleString() : '');

export default function WebUiStatusTrafficPage() {
  const [rows, setRows] = React.useState<Counter[]>([]);
  const [error, setError] = React.useState<string | null>(null);

  const reload = React.useCallback(async () => {
    const data = await postWebUiApi<Counter[]>({
      service: 'interface',
      access: 'get',
      command: 'get counters',
    });
    setRows((data ?? []).slice().sort((a, b) => a.interface - b.interface));
  }, []);

  React.useEffect(() => {
    let alive = true;
    const load = async () => {
      try {
        await reload();
        if (alive) setError(null);
      } catch (err) {
        if (alive) setError((err as Error).message);
      }
    };
    load().catch(() => {});
    const t = window.setInterval(() => load().catch(() => {}), 3000);
    return () => {
      alive = false;
      window.clearInterval(t);
    };
  }, [reload]);

  return (
    <WebUiPageWrapper titleList={['Status', 'Traffic']}>
      {error ? <WebUiAlert type="error" message={error} /> : null}
      <div className="flex flex-col gap-2">
        <table className="webui-table w-full table-fixed">
          <thead>
            <tr className="webui-table-row-head">
              <th rowSpan={2}>Port</th>
              <th colSpan={5}>Incoming</th>
              <th colSpan={5}>Outgoing</th>
            </tr>
            <tr className="webui-table-row-head">
              <th>Octets</th>
              <th>Unicast Packets</th>
              <th>Non-Unicast Packets</th>
              <th>Discards</th>
              <th>Errors</th>
              <th>Octets</th>
              <th>Unicast Packets</th>
              <th>Non-Unicast Packets</th>
              <th>Discards</th>
              <th>Errors</th>
            </tr>
          </thead>
          <tbody>
            {rows.map((r) => (
              <tr key={r.interface} className="webui-table-row-content">
                <td className="text-center">{r.interface}</td>
                <td className="text-center">{f(r.ifInOctets)}</td>
                <td className="text-center">{f(r.ifInUcastPkts)}</td>
                <td className="text-center">{f(r.ifInNUcastPkts)}</td>
                <td className="text-center">{f(r.ifInDiscards)}</td>
                <td className="text-center">{f(r.ifInErrors)}</td>
                <td className="text-center">{f(r.ifOutOctets)}</td>
                <td className="text-center">{f(r.ifOutUcastPkts)}</td>
                <td className="text-center">{f(r.ifOutNUcastPkts)}</td>
                <td className="text-center">{f(r.ifOutDiscards)}</td>
                <td className="text-center">{f(r.ifOutErrors)}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </WebUiPageWrapper>
  );
}
